// extracted by mini-css-extract-plugin
export default {"heading":"UserManagementUsersEditTemplate_heading__xH4Bf","buttonLink":"UserManagementUsersEditTemplate_buttonLink__NVJ9W"};